var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompletedTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21.1245C2.00176 22.1598 2.84022 22.9982 3.87553 23H21.1245C22.1598 22.9982 22.9982 22.1598 23 21.1245V3.87553C22.9982 2.8402 22.1598 2.00175 21.1245 2H3.87553C2.8402 2.00176 2.00175 2.84022 2 3.87553V21.1245ZM2.75056 3.87553C2.75056 3.25416 3.25416 2.75056 3.87553 2.75056H21.1245C21.7458 2.75056 22.2494 3.25416 22.2494 3.87553V21.1245C22.2494 21.7458 21.7458 22.2494 21.1245 22.2494H3.87553C3.25416 22.2494 2.75056 21.7458 2.75056 21.1245V3.87553Z",
    fill: "#BF1E2E",
    stroke: "#BF1E2E",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38058 17.7737C9.53801 17.9303 9.75436 18.0123 9.97624 17.9985C10.1972 17.9847 10.4025 17.8769 10.5397 17.7019L17.9693 8.00328C18.019 7.9388 18.0071 7.84668 17.9426 7.79694L16.9483 7.02964C16.9179 7.00661 16.8811 6.99648 16.8433 7.00109C16.8056 7.00661 16.7715 7.02596 16.7485 7.05636L10.1252 15.703C10.057 15.7905 9.95392 15.8449 9.84344 15.8532C9.73204 15.8615 9.62248 15.8228 9.54148 15.7463L7.13656 13.395C7.1117 13.3683 7.07671 13.3526 7.03989 13.3517C7.00306 13.3508 6.96715 13.3646 6.94045 13.3895L6.04005 14.2894C5.98665 14.3438 5.98665 14.4313 6.04005 14.4856L9.38058 17.7737Z",
    fill: "#BF1E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompletedTasks);
export default __webpack_public_path__ + "static/media/iconCompletedTasks.9a010368f93645411b0e25a86d3f0378.svg";
export { ForwardRef as ReactComponent };